<template>
  <div class="auth_container">
    <div class="container">
      <div class="form_container">
        <v-row>
          <v-col cols="12" md="6">
            <div class="auth_image_container">
              <div class="auth-group-1">
                <img src="@/assets/images/group-1.png" />
              </div>
              <div class="auth-main-image">
                <img src="@/assets/images/laptop.png" />
              </div>
              <div class="auth-group-2">
                <img src="@/assets/images/group-2.png" />
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="auth_form_container">
              <div class="form_header_part">
                <div class="form_header_title">
                  Get more of courses by <span>joining for free</span>
                </div>
                
              </div>
              
              <form v-if="!registerForm && !smsSent" @submit.prevent="submit">
                <div class="input-container">
                  <i class="fa fa-phone icon"></i>
                  <v-text-field
                    class="input-field"
                    v-model="phone_number"
                    type="text"
                    maxlength="10"
                    required
                    dense
                    filled
                    solo
                    placeholder="Phone Number"
                  />
                  
                </div>
                
                <div class="form_error_wrapper mb-2" v-if="errormsg" style="width: 100%; margin-top: -30px;">
                  <span class="red--text body-2" >{{errormsg}}</span>
                </div>
                <div
                  id="recaptcha-container"
                  v-show="!registerForm && !smsSent"
                  class="mb-5"
                ></div>
                <v-btn
                  type="button"
                  @click.prevent="submit"
                  class="btn big_blue_button"
                  :loading="loading"
                  :disabled="loading"
                  id="log-in"
                >
                  Next
                </v-btn>
              </form>
              <form
                v-if="smsSent"  
                class="verify-otp"
                @submit.prevent="verifyCode"
              >
                  <div class="form_header_title mb-4">
                    Enter Verification Code
                  </div>
                  <div class="input-container">
                    <i class="fa fa-phone icon"></i>
                    <input
                      class="input-field"
                      type="text"
                      id="otpField"
                      pattern="[0-9]{6}"
                      maxlength="6"
                      v-model="otpnum"
                      placeholder="Enter verificatoin code"
                      required
                    />
                    
                  </div>
                  <div class="form_error_wrapper mb-2" v-if="errormsg" style="width: 100%; margin-top: -30px;">
                    <span class="red--text body-2">{{errormsg}}</span>
                  </div>
                  <v-btn
                    id="otp-btn"
                    @click="verifyCode"
                    type="button"
                    class="btn big_blue_button"
                    :loading="loading"
                    :disabled="loading"
                  >
                    Confirm
                  </v-btn>
              
              </form>
              <v-form
                v-if="registerForm"
                class="register-form"
                @submit.prevent="register()"
              >
                  <div class="form_header_title mb-4">Register</div>
                  <div class="form_error_wrapper mb-2" v-if="errormsg && errormsg.phone_number" style="width: 100%;">
                    <span class="red--text body-2" >{{errormsg.phone_number[0]}}</span>
                  </div>
                  <div class="input-container">
                    <i class="fa fa-envelope icon"></i>
                    <v-text-field
                      class="input-field"
                      v-model="formData.email"
                      :error-messages="emailErrors"
                      type="email"
                      required
                      dense
                      filled
                      solo
                      placeholder="Email ID"
                      @input="$v.formData.email.$touch()"
                      @blur="$v.formData.email.$touch()"
                    />
                  </div>
                  <div class="form_error_wrapper mb-2" v-if="errormsg && errormsg.email" style="width: 100%; margin-top: -30px;">
                    <span class="red--text body-2" >{{errormsg.email[0]}}</span>
                  </div>
                  <div class="input-container">
                    <i class="fa fa-user icon"></i>
                    <v-text-field
                      class="input-field"
                      v-model="formData.first_name"
                      :error-messages="first_nameErrors"
                      type="text"
                      required
                      dense
                      filled
                      solo
                      placeholder="First name"
                      @input="$v.formData.first_name.$touch()"
                      @blur="$v.formData.first_name.$touch()"
                    />
                    
                  </div>
                  <div class="input-container">
                    <i class="fa fa-user icon"></i>
                    <v-text-field
                      class="input-field"
                      v-model="formData.last_name"
                      :error-messages="last_nameErrors"
                      type="text"
                      required
                      dense
                      filled
                      solo
                      placeholder="Last name"
                      @input="$v.formData.last_name.$touch()"
                      @blur="$v.formData.last_name.$touch()"
                    />
                    
                  </div>
                  
                  <v-btn type="button" class="btn big_blue_button" @click.prevent="register" :loading="loading" :disabled="loading">
                    Register
                    <!-- <template v-slot:loader>
                        <span>Loading...</span>
                    </template> -->
                  </v-btn>
              </v-form>
              <div class="form-footer-text">
                <div class="sign-up-text">
                  Have an account already ?
                  <router-link to="/login">Sign in from HERE !</router-link>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
// This import loads the firebase namespace along with all its type information.
import firebase from "firebase/app";
// These imports load individual services into the firebase namespace.
import "firebase/auth";
import { validationMixin } from 'vuelidate'
import { required, email} from 'vuelidate/lib/validators'
export default {
  name: "register",
  data() {
    return {
      phone_number: "",
      show1: false,
      user: {},
      formData: {},
      errormsg: null,
      confirmationResult: null,
      otpnum: '',
      recaptchaVerifier: null,
      recaptchaWidgetId: null,
      confirmResult: null,
      smsSent: false,
      registerForm: false,
      loader: null,
      loading: false,
    };
  },
  
  mixins: [validationMixin],
  validations: {
    formData: {
      first_name: {
        required
      },
      last_name: {
        required
      },
      email: {
        required,
        email
      },
    },
  },
  mounted() {
    firebase.auth().useDeviceLanguage();
    this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier("log-in", {
      size: "invisible",
      callback: (response) => {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        // console.log(response);
      },
    });
    // this.register()
  },
  computed: {
    emailErrors() {
      const errors = []
      if(!this.$v.formData.email.$dirty) return errors
      !this.$v.formData.email.email && errors.push('Must be valid e-mail')
      !this.$v.formData.email.required && errors.push('E-mail is required')
      return errors
    },
    first_nameErrors() {
      const errors = []
      if(!this.$v.formData.first_name.$dirty) return errors
      !this.$v.formData.first_name.required && errors.push('First Name is required')
      return errors
    },
    last_nameErrors() {
      const errors = []
      if(!this.$v.formData.last_name.$dirty) return errors
      !this.$v.formData.last_name.required && errors.push('Last Name is required')
      return errors
    },
  },
  methods: {
    submit() {
      if(this.phone_number === '' || this.phone_number === null) {
        this.errormsg = "Phone Number is required"
      }
      else {

        this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
          "recaptcha-container"
        );
        this.recaptchaVerifier.render().then((widgetId) => {
          this.recaptchaWidgetId = widgetId;
        });
        
        var number = "+977" + this.phone_number;
        firebase
          .auth()
          .signInWithPhoneNumber(number, this.recaptchaVerifier)
          .then((confirmationResult) => {
            this.confirmResult = confirmationResult;
            this.smsSent = true;
            
            if(this.errormsg) {
              this.smsSent = false;
            }
          })
          .catch((error) => {
            this.errormsg = error;
          });
          this.loader = 'loading'
      }
    },
    async verifyCode() {
      if(this.otpnum === '' || this.otpnum === null) {
        this.errormsg = "OTP number is required"
      }
      else {
        this.confirmResult
          .confirm(this.otpnum)
          .then((result) => {
            
            this.user = result.user;
            this.gotonext();
            
              if(this.errormsg) {
                this.smsSent = false;
              }
          })
          .catch((error) => {
            this.errormsg = error
          });
          this.loader = 'loading'
      }
    },

    gotonext() {
      this.smsSent = false;
      this.registerForm = true;
    },
    async register() {
      this.formData.phone_number = this.user.phoneNumber;
      this.loader = 'loading'
      let self = this
      self.$v.$touch();
      firebase.auth().currentUser.getIdToken(/* forceRefresh */ false).then(async function(idToken) {
        await self.$api.postFirebase("authuser/signup/", self.formData, idToken ).then(async (res)=>{
            self.user = res;
            await localStorage.setItem("user", JSON.stringify(self.user));
            
            if(self.user) {
              self.$bus.emit('loading-toggle');
              self.$router.push("/allcourse");
              location.reload();
            }   
        })
        // ...
      }).catch(function(error) {
        self.errormsg = error.response.data;
        // if(self.errormsg === error) {
        //   self.errormsg = 'This emails is already registered with us'
        //   console.log(self.errormsg)
        // }

      });
    },
  },
  watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 3000)

        this.loader = null
      },
    },
};
</script>
<style lang="scss" scope>
  .verify-otp {
    iframe {
      display: none;
    }
    .input-container div {
      width: auto !important;
      height: auto !important;
    }
  }
  .form_error_wrapper {
    .body-2 {
      line-height: 1.3;
    }
  }
</style>